import { useEffect, useRef, useState } from 'react';

import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Input from 'components/shared/Input/Input';

const TextInput = ({ initialOpenState = false, values, onApply, position = 'right', ...rest }) => {
  const [inputValues, setInputValues] = useState(values);
  const [open, setOpen] = useState(initialOpenState);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [open]);

  const onApplyHandler = () => {
    onApply(inputValues);
    setOpen(false);
  };

  const onChange = (value) => {
    setInputValues(value);
  };

  const isDisabled = !inputValues;

  const buttonText = values || 'Enter text';

  return (
    <div className="relative">
      <Button
        onClick={() => setOpen((prev) => !prev)}
        className="whitespace-nowrap"
        text={buttonText}
        {...rest}
      />
      {open && (
        <div
          className={cn(
            'absolute z-[100] mt-2 flex w-fit items-center gap-2 rounded bg-white p-2 shadow-xs',
            position === 'left' && 'right-0',
            position === 'right' && 'left-0'
          )}>
          <Input
            forwardedRef={inputRef}
            type="text"
            placeholder="Enter text..."
            inputWrapperClassName="w-[172px] min-w-[172px]"
            value={inputValues}
            onChange={(e) => onChange(e.target.value)}
          />
          <Button text="Apply" onClick={onApplyHandler} isDisabled={isDisabled} />
        </div>
      )}
    </div>
  );
};

export default TextInput;
